import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ITreeTradeArray } from 'models/treeTradeActivity';

import { ITreeTradeData } from '../../initialState';

interface IGetTreeTradeSuccessWithDataAction {
  treeTrade: ITreeTradeArray[];
}

function getTreeTradeSuccess(
  draft: Draft<ITreeTradeData>,
  action: PayloadAction<IGetTreeTradeSuccessWithDataAction>,
) {
  draft.getTreeTrade.config.isLoading = false;
  draft.getTreeTrade.treeTrade = action.payload.treeTrade;
}

export default getTreeTradeSuccess;
